import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserTasksRoutes } from 'src/app/core/enums/routes.enum';
import { WorkType } from 'src/app/task-user/components/enum/work-type.enum';
import { ReactivateTask, RestoreTask } from 'src/app/task-user/state/task.actions';
import { Privileges } from 'src/app/core/privileges/privileges';
import { TenantUserPrivilegesService } from 'src/app/tenant-selector/services/tenant-user-privileges.service';

@Component({
  selector: 'app-task-overview-template',
  templateUrl: './task-overview-template.component.html',
  styleUrls: ['./task-overview-template.component.scss'],
  standalone: false,
})
export class TaskOverviewTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;

  Privileges = Privileges;
  performRoute = UserTasksRoutes.Perform;
  isHACCP = false;
  hasPermissionToPerform = false;

  constructor(
    private store: Store,
    private tenantUserPrivileges: TenantUserPrivilegesService
  ) {}

  ngOnInit(): void {
    this.isHACCP = this.element.type === WorkType.Haccp;
    this.hasPermissionToPerform = this.tenantUserPrivileges.userHasPrivilege(
      this.isHACCP ? Privileges.HaccpPerform : Privileges.TaskPerform
    );
  }

  restore(): void {
    this.store.dispatch(new RestoreTask(this.element.id));
  }

  reactivate(): void {
    this.store.dispatch(new ReactivateTask(this.element.id));
  }
}
